// Magic UI NumberTicker, MIT: https://magicui.design/r/number-ticker.json
import React, { useEffect, useRef } from 'react';
import { useInView, useMotionValue, useSpring, useReducedMotion } from 'motion/react';

export const NumberTicker = ({ value, className, ...props }) => {
  const ref = useRef(null);
  const entered = useInView(ref, { once: true });
  const reduced = useReducedMotion();
  const motionValue = useMotionValue(0);
  const spring = useSpring(motionValue, { damping: 60, stiffness: 100 });
  useEffect(() => { if (entered && !reduced) motionValue.set(value); }, [entered, value, motionValue, reduced]);
  useEffect(() => {
    if (reduced) return;
    return spring.on('change', latest => { if (ref.current) ref.current.textContent = Math.round(latest).toLocaleString('hr-HR'); });
  }, [spring, reduced]);
  return <span ref={ref} className={className} aria-label={String(value)} {...props}>{reduced ? value.toLocaleString('hr-HR') : 0}</span>;
};